import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare /courses/:id is just an entry point — send to the Content tab, which is
// the default reading surface (mirrors the old Next index redirect).
export const Route = createFileRoute('/_learner/courses_/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/courses/$id/content', params: { id: params.id } });
  },
});
